import React from 'react'
import MessageBanner from 'components/Luxkit/Banners/MessageBanner'
import BodyTextBlock from 'components/Luxkit/TextBlocks/BodyTextBlock'
import Group from 'components/utils/Group'
import BodyText from 'components/Luxkit/Typography/BodyText'
import SolidFireIcon from 'components/Luxkit/Icons/solid/SolidFireIcon'
import Image from 'components/Common/Image/Image'
import FormatCurrency from '../FormatCurrency'

interface Props {
  carrierLogo?: string;
  carrierName: string;
  destinationName: string;
  price: number;
  nights: number;
  onViewDetails: () => void;
}

function UpsellBanner(props: Props) {
  const {
    carrierLogo,
    carrierName,
    destinationName,
    price,
    nights,
    onViewDetails,
  } = props

  return (
    <MessageBanner
      description={
        <Group direction="horizontal" verticalAlign="center" gap="0 12">
          {carrierLogo && (
            <Image
              width={100}
              image={{ url: carrierLogo, title: carrierName }}
            />
          )}

          <Group direction="vertical" gap={4}>
            <BodyTextBlock variant="medium" weight="bold">
              <BodyText variant="medium" colour="urgency" as="span">
                <SolidFireIcon /> Limited time flight deal:
              </BodyText>{' '}
              {nights} nights + return flights to {destinationName} from
              {' '}<FormatCurrency value={price} format="roundedDollar" />{' '}
              for 2 adults with {carrierName}
            </BodyTextBlock>

            <BodyTextBlock variant="small">
              Available when you book hotel + flight packages below. Don’t miss
              out!
            </BodyTextBlock>
          </Group>
        </Group>
      }
      primaryActionButtonProps={{
        children: 'View details',
        onClick: onViewDetails,
      }}
      kind="promotional-primary"
    />
  )
}

export default UpsellBanner
